<template>
    <v-dialog persistent no-click-animation v-model="show" width="450">
        <div class="QCBatchPermissionEditor">
            <!--Header dialog-->
            <div class="dialog-header">
                <div>{{ $f.tc('chooseTypeReport') }}</div>
                <v-btn small icon @click="close">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </div>
            <!--Content dialog-->
            <div class="px-10 py-10">
                <v-form ref="form" v-model="formValid">
                    <div class="display-flex align-center">
                        <v-select
                            v-model="typeReport"
                            :items="typeReports"
                            :rules="formRules.required"
                            class="input-custom"
                            item-value="key"
                            item-text="value"
                        ></v-select>
                        <div class="btn-primary ml-10" @click="submit">{{ $f.tc('add') }}</div>
                    </div>
                </v-form>
            </div>
        </div>
    </v-dialog>
</template>

<script>
import DialogPromiseFormMixin from '@/modules/fptai/mixins/DialogPromiseFormMixin'
import FormMixin from '@/modules/fptai/mixins/FormMixin'

export default {
    name: 'ChooseTypeEmailReport',
    mixins: [DialogPromiseFormMixin, FormMixin],
    props: {
        typeReports: {
            type: Array,
            default: () => []
        }
    },
    data () {
        return {
            options: [],
            addCallList: [],
            typeReport: ''
        }
    },
    methods: {
        submitValidForm () {
            this.chooseTypeReport()
        },
        close () {
            this.show = false
            this.typeReport = ''
        },
        chooseTypeReport () {
            this.$emit('chooseTypeReport', this.typeReport)
            this.close()
        }
    }
}
</script>

<style scoped lang="scss">
.QCBatchPermissionEditor {
    background: #FFFFFF;
    border-radius: 0 !important;
    overflow: hidden;

    .dialog-header {
        border-bottom: 1px solid #DADFEC;
    }

    .dialog-content {
        padding: 12px;
        max-height: 500px;
        overflow-y: auto;
    }

    .dialog-footer {
        justify-content: center;
        padding: 10px;
        border-top: 1px solid #DADFEC;
    }
}

table.table-assignees {
    border-collapse: collapse;
    width: 100%;
    font-size: 14px;

    tr {
        td {
            border: 1px solid #DADFEC;
            height: 40px !important;
            padding: 0 10px;
        }

        td:last-child {
            width: 67px;
            text-align: center;
        }
    }
}

.input-custom {
    position: relative;

    ::v-deep {
        .v-input__slot {
            height: 36px;
            background: #FFFFFF;
            border-radius: 0;
            border: 1px solid #DADFEC;
            outline: none;
            font-size: 14px;
            padding: 6px 10px 6px 10px;
            margin: 0;
            display: flex;
            align-items: center;

            &:before, &:after {
                border: none !important;
            }
        }
    }
}

::v-deep {
    .v-text-field {
        margin-top: 0 !important;
        padding-top: 0 !important;
    }

    .v-text-field__details {
        position: absolute;
        right: 36px !important;
        top: 11px !important;
    }

    .v-input input {
        height: 36px;
    }
}
</style>

